module.exports = __webpack_public_path__ + "img/chargingpoint-realized.1d8056a4.png";